import { Outlet } from 'react-router-dom';
import { ReactComponent as Logo } from '../../assets/osavul-full.svg';
import { useShareSentryTags } from '../../hooks/useShareSentryTags';

export function LayoutShare() {
  useShareSentryTags();

  return (
    <div className="share-layout">
      <div className="main-content">
        <header>
          <h1>
            <span>
              <Logo />
              {/* <img src="/static/logo-full.svg" alt="OSavul - logo" /> */}
            </span>
          </h1>
        </header>
      </div>

      <main>
        <Outlet />
      </main>
    </div>
  );
}
